import React, { useState, useRef } from "react";
import Alert from "@material-ui/lab/Alert";
import { Snackbar } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { store } from "../../store";
import { setAlertAction } from "../../reducers";
import { ALERT_TYPE_ERROR, ALERT_TYPE_SUCCESS } from "./custom-alert-constants";
import { getErrorMessage } from "../../utils/utils";
import { useIntl } from "react-intl";

const CustomAlert = () => {
  const alertRef = useRef();
  const { dispatch } = store;
  const intl = useIntl();

  const alertMessage = useSelector((state) => state.alert);
  const { showFail, showSuccess, code, message, text } = alertMessage;

  const vertical = "top";
  const horizontal = "center";
  const autoHideDuration = 5000;

  const [severity, setSeverity] = useState("");
  const [show, setShow] = useState(alertMessage?.showFail || alertMessage?.showSuccess);
  const [displayedText, setDisplayedText] = useState("");

  const handleClose = () => {
    dispatch(setAlertAction(false, false, "", ""));
    setShow(false);
  };

  const renderErrorText = () => {
    if (!!text) {
      return text;
    } else if (!!message) {
      return intl.formatMessage({ id: message.id }, message.options);
    } else if (!!code) {
      return intl.formatMessage({ id: getErrorMessage(code) });
    } else {
      return intl.formatMessage({ id: "http_error.generic_message" });
    }
  };

  useEffect(() => {
    setShow(showFail || showSuccess);
    setSeverity(showFail ? ALERT_TYPE_ERROR : showSuccess ? ALERT_TYPE_SUCCESS : "");
    setDisplayedText(renderErrorText());
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  return (
    <>
      {!!severity && displayedText ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={show}
          onClose={handleClose}
          key={vertical + horizontal}
          autoHideDuration={autoHideDuration}
        >
          <Alert ref={alertRef} severity={severity}>
            {displayedText}
          </Alert>
        </Snackbar>
      ) : (
        <></>
      )}
    </>
  );
};

export default CustomAlert;
